export default "__VITE_ASSET__Lwlk7hIC__"